<template>
  <v-list-item class="my-1" tabindex="0">
    <v-menu
      v-model="isMenuOpened"
      class="zoox-sidebar-menu"
      content-class="zoox-sidebar-menu-content"
      rounded
      open-on-hover
      offset-x
      open-delay="300"
      close-delay="400"
      @click="onClickMainMenu"
    >
      <template v-slot:activator="{on}">
        <v-btn
          depressed
          text
          :class="menuClass"
          v-on="on"
          @click="onClickMainMenu"
        >
          <v-icon :class="menuOptionClasses">{{ icon }}</v-icon>
        </v-btn>
      </template>
      <v-list class="zoox-sidebar-menu-list" elevation="0">
        <strong class="menu-option-title">{{ title }}</strong>
        <v-list-item
          v-for="(option, index) of options"
          :key="index"
          link
          class="menu-option-item"
          :class="{'is-disabled': option.disabled}"
          :disabled="option.disabled"
          @click="$emit('click', option)"
        >
          <v-list-item-title class="menu-option">
            {{ option.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-list-item>
</template>

<script>
export default {
  name: 'ZNavigationDrawerMenuItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isMenuOpened: false,
    }
  },
  computed: {
    menuClass() {
      return {
        'is-opened': this.isMenuOpened,
        'is-active': this.isActive,
      }
    },
    menuOptionClasses() {
      return {'menu-icon-active': this.isMenuOpened, 'menu-icon': true}
    },
  },
  methods: {
    onClickMainMenu() {
      if (this.route && (!this.options || this.options.length === 0)) {
        this.$emit('click', {route: this.route, title: this.title})
      }
    },
  },
}
</script>

<style lang="scss">
$shadow-size: 4px;

.zoox-sidebar-menu-list {
  padding-right: 12px !important;

  .menu-option {
    color: var(--primary) !important;
    font-size: 0.875rem;
  }

  .menu-option-item {
    min-height: 1.75rem !important;
    height: 1.75rem !important;
    &.is-disabled {
      opacity: 0.5;
    }
  }

  .menu-option-title {
    color: var(--primary) !important;
    font-size: 0.875rem;
    margin-left: 8px;
    margin-right: 8px;
  }
}

.zoox-sidebar-menu-content {
  box-shadow: $shadow-size $shadow-size 6px -6px black !important;
  -webkit-box-shadow: $shadow-size $shadow-size 6px -6px black !important;
  -moz-box-shadow: $shadow-size $shadow-size 6px -6px black !important;
}
</style>

<style lang="scss" scoped>
$animation-duration: 0.2s;

.zoox-sidebar-menu {
  box-shadow: unset !important;
}

.is-active {
  &:not(.is-opened) {
    background-color: var(--white);
    color: var(--primary) !important;
    width: 80% !important;
    margin-left: 4px !important;
  }
}

.is-opened {
  background-color: var(--white);
  color: var(--primary) !important;
  text-align: end;
  position: absolute;
  left: 6px;
  border-radius: 4px;

  &:hover {
    background-color: var(--white);
  }
}

.menu-icon {
  position: absolute !important;
}

.menu-icon-active {
  -webkit-animation: $animation-duration ease-in 0s activate;
  -webkit-animation-fill-mode: forwards;

  animation: $animation-duration ease-in 0s activate;
  animation-fill-mode: forwards;
}

@-webkit-keyframes activate {
  from {
    right: 13px;
  }
  to {
    right: 9px;
  }
}
@keyframes activate {
  from {
    right: 13px;
  }
  to {
    right: 9px;
  }
}
</style>
